<template>
    <div class="toufang_main">
        <div class="toufang1">
            <img src="../img/toufang0708/0.jpg" alt="">
            <div class="line"></div>
            <img src="../img/toufang0708/1.jpg" alt="">
        </div>

        <div class="toufang2">
            <div class="toufang2_box"  @click="handleClick" >
                <img src="../img/toufang0708/toufanglist/1.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/2.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/3.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/4.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/5.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/6.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/7.jpg" alt="">
                <img src="../img/toufang0708/toufanglist/8.jpg" alt="">
            </div>  
        </div>

        <div class="toufang3">
            <img src="../img/toufang0708/2.jpg" alt="">
        </div>

        <div class="toufang4">
            <div class="toufamg4_title_box">
                <div class="toufamg4_title_list" v-for="(item,index) in tabs" :key="index" :class="{active:activeTab === index}" @click="changeTab(index)">
                    {{ item }}
                </div>
                
            </div>
            <div class="toufamg4_cont" v-show="(activeTab === 0)">
                <div class="toufamg4_item toufamg4_item1">艺术与人文</div>
                <div class="toufamg4_item toufamg4_item2">绘画</div>
                <div class="toufamg4_item toufamg4_item3">设计史</div>
                <div class="toufamg4_item toufamg4_item4">写作</div>
                <div class="toufamg4_item toufamg4_item4">摄影</div>
                <div class="toufamg4_item toufamg4_item3">当代艺术策划/实践</div>
                <div class="toufamg4_item toufamg4_item1">雕塑</div>
                <div class="toufamg4_item toufamg4_item2">印刷</div>
                <div class="toufamg4_item toufamg4_item1">陶瓷与玻璃</div>
                <div class="toufamg4_item toufamg4_item2">珠宝与金属</div>
                <div class="toufamg4_item toufamg4_item3">纯艺术</div>
                <div class="toufamg4_item toufamg4_item5" @click="handleClick">更多>></div>
            </div>
            <div class="toufamg4_cont" v-show="(activeTab === 1)" >
                <div class="toufamg4_item toufamg4_item1">设计</div>
                <div class="toufamg4_item toufamg4_item2">产品设计</div>
                <div class="toufamg4_item toufamg4_item3">服装设计</div>
                <div class="toufamg4_item toufamg4_item4">服务设计</div>
                <div class="toufamg4_item toufamg4_item4">医疗保健设计</div>
                <div class="toufamg4_item toufamg4_item3">全球创新设计</div>
                <div class="toufamg4_item toufamg4_item1">智能移动</div>
                <div class="toufamg4_item toufamg4_item2">纺织品设计</div>
                <div class="toufamg4_item toufamg4_item1">创新设计工程</div>
                <div class="toufamg4_item toufamg4_item5" @click="handleClick">更多>></div>
            </div>
            <div class="toufamg4_cont" v-show="(activeTab === 2)">
                <div class="toufamg4_item toufamg4_item1 toufamg4_item33">动画</div>
                <div class="toufamg4_item toufamg4_item2 toufamg4_item33">视觉传达</div>
                <div class="toufamg4_item toufamg4_item3 toufamg4_item33">传达设计</div>
                <div class="toufamg4_item toufamg4_item4 toufamg4_item33">数字反向</div>
                <div class="toufamg4_item toufamg4_item4 toufamg4_item33">信息体验设计</div>
                <div class="toufamg4_item toufamg4_item5 toufamg4_item33" @click="handleClick">更多>></div>
            </div>
            <div class="toufamg4_cont" v-show="(activeTab === 3)">
                <div class="toufamg4_item toufamg4_item1">建筑设计</div>
                <div class="toufamg4_item toufamg4_item2">城市设计</div>
                <div class="toufamg4_item toufamg4_item3">环境建筑</div>
                <div class="toufamg4_item toufamg4_item4">室内设计</div>
            </div>

            <div class="toufang4_btn">
                <img src="../img/toufang0708/111.png" alt="">
                <p class="toufang4_text" @click="handleClick">留学专家一对一咨询</p>
            </div>

        </div>
        

        <div class="toufang5">
            <img class="img" src="../img/toufang0708/3.jpg" alt=""  @click="handleClick">>
            <img class="img" src="../img/toufang0708/5.jpg" alt="">
            <div class="toufang5_btn">
                <img src="../img/toufang0708/111.png" alt="">
                <p class="toufang4_text" @click="handleClick">领取申请文书指南包</p>
            </div>
            <img class="img" src="../img/toufang0708/6.jpg" alt="">
            <div class="toufang4_btn">
                <img src="../img/toufang0708/111.png" alt="">
                <p class="toufang4_text" @click="handleClick">领取作品集案例</p>
            </div>
            <div style="font-size: .17rem;width: 88%;margin: 0 auto 1rem;text-align: center;padding: 0 0 .1rem;">
                Copyright © 2020-2024 上海洛素文化艺术有限公司, All Rights Reserved.
              </div>
        </div>
        <div style="height: .7rem;">

        </div>
        

        <div class="toufang6">
            <div class="toufang6_btn" @click="handleClick">艺术留学咨询</div>
            <div class="toufang6_btn toufang6_btn2" @click="handleClick">作品集培训</div>
        </div>
        

        

    </div>
</template>

<script>
import '@/assets/css/toufang.css'
export default {
    data(){
        return{
            activeTab:0,
            tabs:['人文艺术','设计学院','传达学院','建筑学院'],
            
        }

    },
    methods:{
        changeTab(index){
        
            this.activeTab = index
        
        },
        handleClick(){
            var msg_tip = document.getElementById("msg_tip")
            msg_tip.click()
            // console.log(msg_tip);
            // this.$store.commit('jopkefu');
        
        },
        getNavFoot(){
            var section_bot = document.getElementsByClassName("section_bot")
            var nav_bottom = document.getElementsByClassName("nav_bottom")
            var nav = document.getElementsByTagName("nav")
            var mobile_minchat_div = document.getElementById("mobile_minchat_div")
            section_bot[0].style.display = "none"
            nav[0].style.display = "none"
            nav_bottom[0].style.display = "none"
            // mobile_minchat_div.style.display = "none"
            // console.log(,nav[0]);
        }
    },
    created(){
        this.getNavFoot()
    },
    mounted(){
        this.getNavFoot()
    }

}
</script>

<style>

</style>